import React, {useEffect} from 'react';
import "bootstrap";
import {BrowserRouter} from "react-router-dom";
import RenderRoutes from "./router/RenderRoutes";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "./store/utility-slice";
import {fetchAuthUser, fetchToken, getUserRole, setUserRole} from "./store/auth-slice"
import Loader from "./components/ui/Loader";
import SelectRole from "./components/SelectRole";
import {fetchTransactionType} from "./store/menu-slice";
import {isVendorRoute} from "./components/Utility";
import {fetchVendorToken} from "./store/vendor-slice";

const App = () => {
    const dispatch = useDispatch();
    const isLoader = useSelector(state => state.utility.isLoading);
    const isVendorRoutes = isVendorRoute();

    useEffect(() => {
        dispatch(fetchToken());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchVendorToken());
    },[dispatch])

    const {
        isValid,
        user,
        selectedRole,
        fetchUserStatus
    } = useSelector(state => state.auth);

    useEffect(() => {
        if (isValid) {
            Promise.all([
                dispatch(fetchAuthUser()),
                dispatch(getUserRole())
            ])
                .then(() => {
                    // Process the fetched data
                    dispatch(setLoading(false));
                })
                .catch((error) => {
                    dispatch(setLoading(false));
                });
        }
    }, [isValid, dispatch]);
    const userRole = useSelector((state) => state.auth.selectedRole);
    useEffect(() => {
        if (userRole !== null && userRole.scope === "Restaurant") {
            dispatch(fetchTransactionType(userRole))
        }
    }, [dispatch, userRole]);

    const selectRoleHandler = (selectedRole) => {
        dispatch(setUserRole(selectedRole));
    }

    return (
        <BrowserRouter basename="/">
            {!isVendorRoutes && isLoader && <Loader/>}
            {fetchUserStatus === "success" && isValid && user && !selectedRole && (
                <SelectRole
                    user={user}
                    onSelectRole={selectRoleHandler}
                />
            )}
            <RenderRoutes/>
        </BrowserRouter>
    );
};
export default App;

